module.exports = __webpack_public_path__ + "static/media/FM_EU_Order_Execution_Policy_March_2025.6d03bcf0.pdf";